// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Emotion = require("emotion");
var TicTacToe$ReactTemplate = require("./TicTacToe.bs.js");

function App(Props) {
  var useBrokenLogic = Props.useBrokenLogic;
  return React.createElement("div", {
              className: Emotion.css("display: flex; flex-direction: column; align-items: center;")
            }, React.createElement("h1", undefined, "Tic Tac Toe"), React.createElement(TicTacToe$ReactTemplate.make, {
                  useBrokenLogic: useBrokenLogic
                }));
}

var make = App;

exports.make = make;
/* react Not a pure module */
